import React, { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppContext from "context/Context";
import classNames from "classnames";
import NavbarTop from "components/navbar/top/NavbarTop";
import NavbarVertical from "components/navbar/vertical/NavbarVertical";
// import PlanAlert from "../components/Pricing/PlanAlert";

const MainLayout = () => {
  const { hash, pathname } = useLocation();

  const {
    config: { isFluid },
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? "container-fluid" : "container"}>
      <NavbarVertical />

      <div className={classNames("content")}>
        <NavbarTop />
        {/*------ Main Routes ------*/}
        <Outlet />
      </div>
      {/* <PlanAlert /> */}
      </div>
  );
};

export default MainLayout;
